export default function convertItemToUpdate(data, templateType, answerType, instructionalContentSubtype) {
  return {
    id: parseInt(data.id, 10),
    type: data.type,
    attributes: {
      'created-at': data.createdAt,
      'study-type': data.studyType,
      'note-type': data.noteType,
      'note-tab-text': data.noteTabText,
      'explanation-type': data.explanationType,
      'is-studiable': data.isStudiable,
      'graduate-difficulty-enabled': data.graduateDifficultyEnabled,
      position: data.position,
      'container-item-id': data.containerItemId,
      'contained-position': data.containedPosition,
    },
    relationships: {
      facets: { data: data.facets || [] },
      annotations: { data: data.annotations || [] },
      sentences: { data: data.sentences || [] },
      'attached-items': { data: data.attachedItems || [] },
    },
    links: data.links,
    card: {},
    errors: ['missing_template'],
    cardState: 'no_template',
    selected: true,
    expanded: true,
    data: {
      attributes: {
        'answer-type': answerType,
        'ic-subtype': instructionalContentSubtype,
        'template-type': templateType,
      },
    },
    include: 'facets',
  };
}
